
import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const OrderFinancialsBlock = ({ totals, extraInfoText,t }) => {
    if (!totals) return null;

    const {
        subtotal,
        tax,
        shipping,
        paymentMethodLabel,
        paymentMethodValue,
        total,
    } = totals;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: "10px",
                    bgcolor: "#E9E9E9",
                    px: 2,
                    py: 1.5,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 16,
                        color: "#111111",
                    }}
                >
                    <Row label={t("Value without tax")} value={subtotal} />
                    <Row label={t('Vat')} value={tax} />
                    <Row label={t("Shipping")} value={shipping} />
                    <Row label={paymentMethodLabel} value={paymentMethodValue} />

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 1.5,
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                            }}
                        >
                            {t("Final total")}
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                                textAlign: "right",
                            }}
                        >
                            {total}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
            <Box>
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontWeight: 700,
                        fontSize: 14,
                        textTransform: "uppercase",
                        mb: 1,
                        color: "#111111",
                    }}
                >
                    {t("Additional Information")}
                </Typography>

                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: "10px",
                        bgcolor: "#E9E9E9",
                        px: 2,
                        py: 1.5,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: 1.2,
                            color: "#111111",
                        }}
                    >
                        {extraInfoText}
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
};

const Row = ({ label, value }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}
    >
        <Typography>{label}</Typography>
        <Typography sx={{ textAlign: "right" }}>{value}</Typography>
    </Box>
);

export default OrderFinancialsBlock;
